export const PATIENT_FIELD_GROUP = 'CD2.PatientFieldConfiguration';
export const PATIENT_FIELD_GENDER = 'CD2.PatientFieldConfiguration.Gender';
export const PATIENT_FIELD_MEMBERID = 'CD2.PatientFieldConfiguration.MemberId';
export const PATIENT_FIELD_GROUPNUMBER = 'CD2.PatientFieldConfiguration.GroupNumber';
export const PATIENT_FIELD_FIRSTNAME = 'CD2.PatientFieldConfiguration.FirstName';
export const PATIENT_FIELD_MIDDLENAME = 'CD2.PatientFieldConfiguration.MiddleName';
export const PATIENT_FIELD_LASTNAME = 'CD2.PatientFieldConfiguration.LastName';
export const PATIENT_FIELD_ADDRESSLINE1 = 'CD2.PatientFieldConfiguration.AddressLine1';
export const PATIENT_FIELD_ADDRESSLINE2 = 'CD2.PatientFieldConfiguration.AddressLine2';
export const PATIENT_FIELD_CITY = 'CD2.PatientFieldConfiguration.City';
export const PATIENT_FIELD_STATE = 'CD2.PatientFieldConfiguration.State';
export const PATIENT_FIELD_ZIPCODE = 'CD2.PatientFieldConfiguration.ZipCode';
export const PATIENT_FIELD_DATEOFBIRTH = 'CD2.PatientFieldConfiguration.DateOfBirth';
export const PATIENT_FIELD_EMAIL = 'CD2.PatientFieldConfiguration.Email';
export const PATIENT_FIELD_HOMEPHONE = 'CD2.PatientFieldConfiguration.HomePhone';
export const PATIENT_FIELD_MOBILEPHONE = 'CD2.PatientFieldConfiguration.MobilePhone';
export const PATIENT_FIELD_ALTERNATEPHONE = 'CD2.PatientFieldConfiguration.AlternatePhone';
export const PATIENT_FIELD_PARENT_OR_GUARDIAN_NAME = 'CD2.PatientFieldConfiguration.ParentOrGuardianName';
